import { getHeaderHeight } from "./helpers";
import { getMiniCart } from "./sections/mini-cart";
import { init as initHeader } from "./sections/header";
import { init as initMiniCart } from "./sections/mini-cart";
import { init as initFooter } from "./sections/footer";
/**
 * Runs logic that is required by every page:
 * header
 * minicart
 */

export const shared = (templateName, templateSuffix) => {
  storeHeaderHeight();
  // Temporarily hide this ( TODO probably needed when QAB has two lines?)
  //window.onresize = debounce(() => storeHeaderHeight(), 1000);

  // Header container = announcement bar + header
  const headerContainer = document.getElementById("header-container");

  //const header = document.querySelector(".shopify-section.header");
  if (headerContainer instanceof HTMLElement) {
    initHeader(headerContainer);
  }
  const footerContainer = document.querySelector("#shopify-section-footer");
  if (footerContainer instanceof HTMLElement) {
    initFooter(footerContainer);
  }
  const minicart = getMiniCart();
  if (minicart) {
    initMiniCart(minicart);
  }
};

/**
 * Measures header space and sets a css variable on the root element.
 */
export function storeHeaderHeight() {
  const heightPixels = getHeaderHeight();
  const root = document.querySelector(":root");

  if (root instanceof HTMLElement) {
    root.style.setProperty("--header-height", `${heightPixels}px`);
  }
}
